.more {
  margin-top: var(--sp-8);
  text-align: center;
}
